import { LOCAL_STORAGE_KEY, type Plan } from "./types";
import { importPlanJson, serializePlan } from "./utp";

export interface StorageLike {
    getItem(key: string): string | null;
    setItem(key: string, value: string): void;
    removeItem(key: string): void;
}

export function saveLocalPlan(storage: StorageLike, plan: Plan): boolean {
    try {
        storage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(serializePlan(plan, plan.project.updatedAt)));
        return true;
    } catch {
        return false;
    }
}

export function restoreLocalPlan(storage: StorageLike): Plan | null {
    try {
        const value = storage.getItem(LOCAL_STORAGE_KEY);
        if (value === null) {
            return null;
        }
        const result = importPlanJson(value);
        return result.ok ? (result.plan ?? null) : null;
    } catch {
        return null;
    }
}

export function clearLocalPlan(storage: StorageLike): boolean {
    try {
        storage.removeItem(LOCAL_STORAGE_KEY);
        return true;
    } catch {
        return false;
    }
}
